import { useContext } from 'react';
import { UserContext } from './context';

export const useUserContext = () => {
  const { user, isAuthenticated, isLoading, signOut, updateUser, getTokens } = useContext(UserContext);

  return {
    user,
    isAuthenticated,
    isLoading,
    signOut,
    updateUser,
    getTokens,
  };
};
